import { Link as RouterLink } from 'react-location';
// @mui
import { Box, BoxProps } from '@mui/material';

import Image from 'src/components/Image';
import SingleLogo from 'src/assets/logo/logo_single.png';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
  path?: string;
}

export default function Logo({ disabledLink = false, sx, path }: Props) {
  const logo = (
    <Box sx={{ ...sx }}>
      <Image src={path ?? SingleLogo} alt="Lovage Labs Logo" />
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
